/*
 * Copyright (c) 2020. American Express Company
 */

import BWDataService from './bw-data.service';
import StorageService, { HOURS, Storage } from './storage.service';

// TODO: Make strongly typed return types
export default class ZillowService extends BWDataService {
    public static async getPropertyByAddress(address: string, cityStateZip: string): Promise<any> {
        const URL = `/zillow/address?address=${address}&citystatezip=${cityStateZip}`;
        const remoteCall = async (): Promise<any> => {
            const response: any = await this.get(URL);
            return response.response.results.result[0];
        };

        return await StorageService.get(encodeURIComponent(URL), null, remoteCall, Storage.session, 24 * HOURS);
    }

    public static async getPropertyByZpid(zpid: string): Promise<any> {
        const URL = `/zillow/zpid?zpid=${zpid}`;
        const remoteCall = async (): Promise<any> => {
            const response: any = await this.get(URL);
            return response.response;
        };

        return await StorageService.get(encodeURIComponent(URL), null, remoteCall, Storage.session, 24 * HOURS);
    }
}
